module.exports = __webpack_public_path__ + "img/diamond.5d5167fc.svg";